import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfirmModelComponent } from '../common/confirm-model/confirm-model.component';
import { WorkflowService } from '../services/workflow-service';
import { GlobalService } from '../services/global.service';
import { AlertComponent } from '../common/alert/alert.component';
import { FilterModel } from '../models/filter/filter-request.model';
import { FilterResponseModel } from '../models/filter/filter-response.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomComponentBuilder } from './custom-component-builder/custom-component-builder';
import { FilterFieldTypes } from '../shared/common-constants';

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['../workflow/workflow.component.css']
})
export class customComponent implements OnInit {
  resourceList: any = [];
  dataToPass: any = [];
  accessTokenFunction: any;
  expandedIndex: any;
  isLoading = true;
  modelErrorMessage = 'Error';
  modelDetails: any;
  customCompListDetails: MatTableDataSource<any>;
  displayedColumns: string[] = ['componentName', 'businessDescription', 'apiUrl', 'createdBy', "lastUpdatedTimeStamp", 'Action'];
  isLinear = false;
  customComponentId: number = 0;
  componentName: string = '';
  componentIdDelete: number;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  bearerToken: string;

  filterList: FilterModel[] = [];
  customTab: boolean = true;
  selectedFilters: FilterResponseModel[] = [];
  masterData: any;
  @ViewChild('popOver') public popover: NgbPopover;
  searchText: string = "";

  constructor(
    public globals: GlobalService,
    public workflowService: WorkflowService,
    public router: Router,
    public route: ActivatedRoute,
    public dialog: MatDialog) {
    const emptyList: any[] = [];
    this.customCompListDetails = new MatTableDataSource(emptyList);
  }

  ngOnInit() {
    this.expandedIndex = -1;
    this.getCustomComponentList();
  }

  getCustomComponentList() {
    this.selectedFilters = [];
    this.workflowService.getCustomComponentList().subscribe((data: any): void => {
      if (data && data !== null && data.length > 0) {
        this.masterData = [...data];
        this.customCompListDetails = new MatTableDataSource(data);
        this.customCompListDetails.sort = this.sort;
        this.customCompListDetails.paginator = this.paginator;
        if (this.filterList.length == 0) {
          this.createFilterList();
        }
      } else {
        this.customCompListDetails.data = [];
      }
      this.isLoading = false;
      this.filterList = [];
      this.createFilterList();
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching Custom Component List" });
      this.isLoading = false;
    });
  }

  deleteWorkflow(selectedCustFun) {
    this.componentIdDelete = selectedCustFun.componentId;
    this.workflowService.getUsedCustomFunction(this.componentIdDelete).subscribe((data: any): void => {
      if (data) {
        this.globals.showAlert(AlertComponent, { success: false, message: "Custom Function: " + selectedCustFun.componentName + " is already used in the Workflow." });
      } else {
        let dataToPass = {
          title: 'Delete',
          isDelete: true,
          message: 'Do you really want to delete it?'
        };
        this.globals.openModelWindow(this.deleteOnConfirm, this, ConfirmModelComponent, '450px', 'confirm-modalbox', dataToPass);
      }
    }, (error: Error) => {
      this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching Custom Function Data" });
      this.isLoading = false;
    });
  }

  deleteOnConfirm(thisRef: customComponent) {
    thisRef.isLoading = true;
    thisRef.workflowService.deleteCustomComponent(thisRef.componentIdDelete).subscribe((result: any): void => {
      if (result == 1) {
        thisRef.getCustomComponentList();
      }
      thisRef.isLoading = false;
      thisRef.customComponentId = 0;
      thisRef.getCustomComponentList();
      thisRef.globals.showAlert(AlertComponent, { success: true, message: "Custom Function deleted successfully!" });
    }, (error: Error) => {
      thisRef.globals.showAlert(AlertComponent, { success: false, message: "Error in deleting Component" });
      thisRef.isLoading = false;
      thisRef.customComponentId = 0;
    });
  }

  checkCustomFunction(clickEvent, custFunData: any) {
    this.isLoading = true;
    if (clickEvent == 'addFunction') {
      this.customComponentAction('addFunction', '');
      this.isLoading = false;
    } else {
      this.workflowService.getCustomComponentData(custFunData.componentId).subscribe((data: any): void => {
        if (data && data !== null && data !== undefined) {
          clickEvent == 'editFunction' ? this.customComponentAction('editFunction', data) : this.customComponentAction('viewFunction', data)
        }
        this.isLoading = false;
      }, (error: Error) => {
        this.globals.showAlert(AlertComponent, { success: false, message: "Error in fetching Custom Function Data" });
        this.isLoading = false;
      });
    }
  }

  customComponentAction(action, custFunData) {
    this.dataToPass = {
      'actionType': action,
      'customFunctionData': custFunData,
      'customNameList': this.customCompListDetails.data.map(item => item.componentName),
      'accessToken': this.accessTokenFunction
    };
    this.openModelWindow(this.updateComponentList, this, CustomComponentBuilder, '80%', 'custom-modalbox', this.dataToPass);
  }

  openModelWindow(componentList, thisRef, modelComponent, widthOfWindow, panelClassName, dataToPass, functionality?) {
    {
      const dialogRef = this.dialog.open(modelComponent, {
        width: widthOfWindow,
        panelClass: panelClassName,
        data: dataToPass,
        disableClose: true
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          componentList(thisRef, result);
          this.getCustomComponentList();
        }
      });
    }
  }

  updateComponentList(thisRef: customComponent, newCompomentAdded: any) {
    if (newCompomentAdded == "added") {
      thisRef.getCustomComponentList();
    }
  }

  /**
  * Filters data based on input text
  * @param filterValue
  */
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim().toLowerCase(); // Remove whitespace and MatTableDataSource defaults to lowercase matches
    this.customCompListDetails.filter = filterValue;
  }

  /**Creates data for filter list */
  createFilterList() {
    let columns: string[] = ['componentName', 'businessDescription', 'createdBy'];

    for (let a = 0; a < columns.length; a++) {
      let tempFilter: FilterModel = new FilterModel();
      let unique;
      tempFilter.fieldName = this.globals.replaceCustomDisplayText(columns[a]);
      if (columns[a] == "componentName") {
        tempFilter.fieldType = FilterFieldTypes.text;
        unique = Array.from(new Set(this.customCompListDetails.data.map(a => a.componentName)));
      } else if (columns[a] == "businessDescription") {
        tempFilter.fieldType = FilterFieldTypes.text;
        unique = Array.from(new Set(this.customCompListDetails.data.map(a => a.businessDescription)));
      } else if (columns[a] == "createdBy") {
        tempFilter.fieldType = FilterFieldTypes.text;
        unique = Array.from(new Set(this.customCompListDetails.data.map(a => a.createdBy)));
      }
      tempFilter.values = unique.sort((n1, n2) => n1 - n2);
      this.filterList.push(tempFilter);
    }
  }

  /**
  * Returns data from child filter component
  * @param event
  */
  filterResponse(event) {
    let filterResponse: FilterResponseModel = event.filterResponse;
    this.customTab = true;
    switch (filterResponse.selectedCondition) {
      case "==":
        this.customCompListDetails.data = this.customCompListDetails.data.filter(
          (df) =>
            df[filterResponse.selectedFieldName] === filterResponse.selectedValue);
        break;
      case ">=":
        this.customCompListDetails.data = this.customCompListDetails.data.filter((df) => df[filterResponse.selectedFieldName] >= parseInt(filterResponse.selectedValue, 10));
        break;
      case "<=":
        this.customCompListDetails.data = this.customCompListDetails.data.filter((df) => df[filterResponse.selectedFieldName] <= parseInt(filterResponse.selectedValue, 10));
        break;
    }
    this.selectedFilters.push(filterResponse);
    if (this.popover.isOpen()) this.popover.close();
  }

  /**
   * Removes that filter
   * @param selectedFilter
   */
  remove(selectedFilter: FilterResponseModel): void {
    const index = this.selectedFilters.indexOf(selectedFilter);
    if (index >= 0) {
      this.selectedFilters.splice(index, 1);
      this.customCompListDetails.data = this.masterData.slice(0);
      if (this.selectedFilters.length > 0) {
        for (let element of this.selectedFilters) {
          this.customCompListDetails.data = this.globals.conditionalDataFiltering(element, this.customCompListDetails.data);
        }
      }
    }
  }

}
